//import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from "react-redux";
import { store, persistor } from './Store';
import "./i18n";
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Auth0Provider } from "@auth0/auth0-react";
import getBaseURL from './Helpers/getBaseURL';

const domain = "dev-z0a5fexelyr63jcb.us.auth0.com";
const clientId = "8uhnpvrSImQnDo5WRxI8W2fGCQAZmdQ7";


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const baseURL = getBaseURL();

console.log("`${baseURL}/front/login`", `${baseURL}/front/login`);

root.render(
  <>
    {/* <StrictMode> */}
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Auth0Provider
          domain={domain}
          clientId={clientId}
          authorizationParams={{
            redirect_uri: `${baseURL}/front/login`,
          }}
        >
          <App />
        </Auth0Provider>
      </PersistGate>
    </Provider>
    {/* </StrictMode>  */}
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
